(function() {
  'use strict';

  angular
    .module('d', ['ngResource', 'ngRoute', 'toastr', 'ngJsTree', 'pdf', 'pageslide-directive']);

})();

(function() {
  'use strict';

  angular
      .module('d')
      .service('webDevTec', webDevTec);

  /** @ngInject */
  function webDevTec() {
    var data = [
      {
        'title': 'AngularJS',
        'url': 'https://angularjs.org/',
        'description': 'HTML enhanced for web apps!',
        'logo': 'angular.png'
      },
      {
        'title': 'BrowserSync',
        'url': 'http://browsersync.io/',
        'description': 'Time-saving synchronised browser testing.',
        'logo': 'browsersync.png'
      },
      {
        'title': 'GulpJS',
        'url': 'http://gulpjs.com/',
        'description': 'The streaming build system.',
        'logo': 'gulp.png'
      },
      {
        'title': 'Jasmine',
        'url': 'http://jasmine.github.io/',
        'description': 'Behavior-Driven JavaScript.',
        'logo': 'jasmine.png'
      },
      {
        'title': 'Karma',
        'url': 'http://karma-runner.github.io/',
        'description': 'Spectacular Test Runner for JavaScript.',
        'logo': 'karma.png'
      },
      {
        'title': 'Protractor',
        'url': 'https://github.com/angular/protractor',
        'description': 'End to end test framework for AngularJS applications built on top of WebDriverJS.',
        'logo': 'protractor.png'
      },
      {
        'title': 'Bootstrap',
        'url': 'http://getbootstrap.com/',
        'description': 'Bootstrap is the most popular HTML, CSS, and JS framework for developing responsive, mobile first projects on the web.',
        'logo': 'bootstrap.png'
      },
      {
        'title': 'Less',
        'url': 'http://lesscss.org/',
        'description': 'Less extends the CSS language, adding features that allow variables, mixins, functions and many other techniques.',
        'logo': 'less.png'
      }
    ];

    this.getTec = getTec;

    function getTec() {
      return data;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('d')
    .directive('acmeNavbar', acmeNavbar);

  /** @ngInject */
  function acmeNavbar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/navbar/navbar.html',
      scope: {
          creationDate: '='
      },
      controller: NavbarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function NavbarController(moment) {
      var vm = this;

      // "vm.creationDate" is available by directive option "bindToController: true"
      vm.relativeDate = moment(vm.creationDate).fromNow();
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('d')
    .directive('acmeMalarkey', acmeMalarkey);

  /** @ngInject */
  function acmeMalarkey(malarkey) {
    var directive = {
      restrict: 'E',
      scope: {
        extraValues: '='
      },
      template: '&nbsp;',
      link: linkFunc,
      controller: MalarkeyController,
      controllerAs: 'vm'
    };

    return directive;

    function linkFunc(scope, el, attr, vm) {
      var watcher;
      var typist = malarkey(el[0], {
        typeSpeed: 40,
        deleteSpeed: 40,
        pauseDelay: 800,
        loop: true,
        postfix: ' '
      });

      el.addClass('acme-malarkey');

      angular.forEach(scope.extraValues, function(value) {
        typist.type(value).pause().delete();
      });

      watcher = scope.$watch('vm.contributors', function() {
        angular.forEach(vm.contributors, function(contributor) {
          typist.type(contributor.login).pause().delete();
        });
      });

      scope.$on('$destroy', function () {
        watcher();
      });
    }

    /** @ngInject */
    function MalarkeyController($log, githubContributor) {
      var vm = this;

      vm.contributors = [];

      activate();

      function activate() {
        return getContributors().then(function() {
          $log.info('Activated Contributors View');
        });
      }

      function getContributors() {
        return githubContributor.getContributors(10).then(function(data) {
          vm.contributors = data;

          return vm.contributors;
        });
      }
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('d')
    .factory('githubContributor', githubContributor);

  /** @ngInject */
  function githubContributor($log, $http) {
    var apiHost = 'https://api.github.com/repos/Swiip/generator-gulp-angular';

    var service = {
      apiHost: apiHost,
      getContributors: getContributors
    };

    return service;

    function getContributors(limit) {
      if (!limit) {
        limit = 30;
      }

      return $http.get(apiHost + '/contributors?per_page=' + limit)
        .then(getContributorsComplete)
        .catch(getContributorsFailed);

      function getContributorsComplete(response) {
        return response.data;
      }

      function getContributorsFailed(error) {
        $log.error('XHR Failed for getContributors.\n' + angular.toJson(error.data, true));
      }
    }
  }
})();

(function () {
    'use strict';

    angular
            .module('d')
            .controller('TvController', TvController);

    /** @ngInject */
    function TvController($timeout, webDevTec, toastr, $scope, $http, $log) {

        var vm = this;



        
        
    }
})();

(function () {
    'use strict';

    angular
            .module('d')
            .service('sessionStorageService', sessionStorageService);

    /** @ngInject */ 
    function sessionStorageService($http, $window) { //$cookieStore

        /**
         * Return session storage
         */
        var getSessionStorage = function () {
            return $window['sessionStorage'];
        };

        /**
         * Return true if browser support session storage
         */
        var isSessionStorageAvailable = function () {
            try {
                var storage = getSessionStorage(),
                        x = '__storage_test__';
                storage.setItem(x, x);
                storage.removeItem(x);
                return true;
            } catch (e) {
                return false;
            }
        };

        /**
         * Gets true is giving key is a cookie name, false otherwise
         * @param {string} key
         * @returns {boolean}
         */
        var isCookie = function (key) {
            return /^OTP-STATE-(.*)-(.*)$|^ep$/.test(key);
        };

        /**
         * private functions for cookies
         */
        var cookies = {
            /*
             get : function(key){
             var value = $cookieStore.get(key);
             // $log.log("SessionStorage.cookies.get : " + key);
             return value;
             },
             getObject : function(key){
             var value = angular.fromJson($cookieStore.get(key));
             // $log.log("SessionStorage.cookies.get : " + key);
             return value;
             },
             put : function(key, value, options){
             // $log.log("SessionStorage.cookies.put : " + key + "(" + angular.toJson(options) + ") = " + value);
             if(angular.isDefined(options) && angular.isDefined(options.expires)){
             // $log.log("SessionStorage.cookies.put : " + key + " = " + value + "; expires=" + options.expires);
             $window.document.cookie = key + "=" + value + "; expires=" + options.expires;
             } else {
             // $log.log("SessionStorage.cookies.put : " + key + " = " + value);
             $cookieStore.put(key, value);
             }
             return value;
             },
             putObject : function(key, value, options){
             var itemValue = value;
             if(angular.isObject(value)){
             itemValue = cookies.put(key, angular.toJson(value), options);
             } else {
             itemValue = cookies.put(key, value, options);
             }
             return angular.fromJson(itemValue);
             },
             remove : function(key){
             var value = $cookieStore.get(key);
             if(angular.isDefined(value) && value !== null){
             // $log.log("SessionStorage.cookies.remove : " + key);
             $cookieStore.remove(key);
             }
             }
             */
        };

        /**
         * private functions for session storage
         */
        var sessionStorage = {
            get: function (key) {
                var value = getSessionStorage().getItem(key);
                if (value === null) {
                    value = undefined;
                }
                return value;
            },
            getObject: function (key) {
                var value = getSessionStorage().getItem(key);
                if (value === null) {
                    value = undefined;
                } else {
                    value = angular.fromJson(value);
                }
                return value;
            },
            put: function (key, value, options) {
                getSessionStorage().setItem(key, value);
                return value;
            },
            putObject: function (key, value, options) {
                var itemValue = value;
                if (angular.isObject(value)) {
                    itemValue = sessionStorage.put(key, angular.toJson(value), options);
                } else {
                    itemValue = sessionStorage.put(key, value, options);
                }
                return angular.fromJson(itemValue);
            },
            remove: function (key) {
                getSessionStorage().removeItem(key);
            },
            clear: function () {
                getSessionStorage().clear();
            }
        };

        /**
         * Returns the value of given key
         * @param {string} key Id to use for lookup.
         * @returns value of given key
         */
        this.get = function (key) {
            var value;
            if (isSessionStorageAvailable() && !isCookie(key)) {
                value = sessionStorage.get(key);
            } else {
                value = cookies.get(key);
            }
            // $log.log("SessionStorage.get : " + key);
            return value;
        };
        /**
         * Returns the value of given key
         * @param {string} key Id to use for lookup.
         * @returns value of given key
         */
        this.getObject = function (key) {
            var value;
            if (isSessionStorageAvailable() && !isCookie(key)) {
                value = sessionStorage.getObject(key);
            } else {
                value = cookies.getObject(key);
            }
            // $log.log("SessionStorage.getObject : " + key);
            return value;
        };
        /**
         * Sets a value for given key
         * @param {string} key Id for the value.
         * @param {string} value Raw value to be stored..
         * @param {Object} Options object. See https://docs.angularjs.org/api/ngCookies/provider/$cookiesProvider#defaults
         */
        this.put = function (key, value, options) {
            var itemValue;
            if (isSessionStorageAvailable() && !isCookie(key)) {
                itemValue = sessionStorage.put(key, value, options);
            } else {
                itemValue = cookies.put(key, value, options);
            }
            // $log.log("SessionStorage.put : " + key + "=" + itemValue);
        };
        /**
         * Sets a value for given key
         * @param {string} key Id for the value.
         * @param {Object} value Value to be stored.
         * @param {Object} Options object. See https://docs.angularjs.org/api/ngCookies/provider/$cookiesProvider#defaults
         */
        this.putObject = function (key, value, options) {
            var itemValue;
            if (isSessionStorageAvailable() && !isCookie(key)) {
                itemValue = sessionStorage.putObject(key, value, options);
            } else {
                itemValue = cookies.putObject(key, value, options);
            }
            // $log.log("SessionStorage.putObject : " + key + "=" + angular.toJson(itemValue));
        };
        /**
         * Remove given key
         * @param {string} key Id of the key-value pair to delete.
         */
        this.remove = function (key) {
            // $log.log("SessionStorage.remove : " + key);
           // TODO cookies.remove(key);
            sessionStorage.remove(key);
        };
        /**
         * The clear() method of the Storage interface, when invoked, will empty all keys out of the storage.
         */
        this.clear = function () {
            // $log.log("SessionStorage.clear");
            cookies.remove("ep");
            sessionStorage.clear();
        };


    }

})();

/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


(function () {
    'use strict';

    angular
            .module('d')
            .factory('AuthenticationService', AuthenticationService);

    /** @ngInject */
    // AuthenticationService.$inject = ['$http', '$rootScope', '$timeout']; $cookies
    function AuthenticationService($timeout, webDevTec, toastr, $log, $rootScope, $http, sessionStorageService, LOGIN_URL) {
        var service = {};

        service.Login = Login;
        service.SetCredentials = null;
        service.ClearCredentials = null;

        return service;

        function Login(username, password, callback) {

            // return $http.get('/api/users').then(handleSuccess, handleError('Error getting all users'));
            /*
             $http.get('localhost:8080/auth/login')
             .then(function() {
             
             }, function() {
             // ('Error getting all users')
             });
             */

            // 'http://localhost:8080/authenticate'
            // http://doclib.jpapou.fr/api/document

            $http({
                method: 'POST',
                url: LOGIN_URL, // PG_BACK_URL

                data: {username: username, password: password}
            }).then(function sucess(response) {
                        // login successful if there's a token in the response
                        if (response.data.token) {

                            var testObject = { username: username, token: response.data.token };
                        
                            sessionStorageService.put("auth", JSON.stringify(testObject));

                            // add jwt token to auth header for all requests made by the $http service
                            // OK    $http.defaults.headers.common.Authorization = 'Bearer ' + response.token;

                            // execute callback with true to indicate successful login
                            callback(true);
                        } else {
                            // execute callback with false to indicate failed login
                            callback(false);
                        }
                    }, function error(response) {
                        callback(false);
                    });








           // var response = {success: true};
          //  callback(response);
        }

    }

})();
    
(function () {
    'use strict';

    angular
            .module('d')
            .controller('MainController', MainController);

    /** @ngInject */
    function MainController($timeout, webDevTec, toastr, $scope, $http, $log, sessionStorageService, $location,
            TREE_URL, PDF_URL, TREE_URL_TEST) {
        var vm = this;

/*
        vm.awesomeThings = [];
        vm.classAnimation = '';
        vm.creationDate = 1500213042615;
*/

//////////////////////////////////////
///////// TREEVIEW ///////////////////

        vm.treeData = [];
        vm.treeConfig = {
            core: {
                multiple: false,
                animation: true,
                error: function (error) {
                    $log.error('treeCtrl: error from js tree - ' + angular.toJson(error));
                },
                check_callback: false,
                worker: false
            },
            types: {
                default: {
                    icon: 'glyphicon glyphicon-flash'
                },
                star: {
                    icon: 'glyphicon glyphicon-star'
                },
                cloud: {
                    icon: 'glyphicon glyphicon-cloud'
                }
            },
            version: 1,
            plugins: ['types', 'search', 'crrm'] //,'checkbox'
        };

        vm.loadDataTest = function () {

            $http({
                method: 'GET',
                url: TREE_URL_TEST,
                headers: {'Authorization': 'Bearer ' + vm.token},
                data: {}
            }).then(function sucess(data) {
                // login successful if there's a token in the response
                //  vm.treeData = data.data;
                vm.treeData = [];

                vm.treeData = data.data;
                vm.treeConfig.version++;


            }, function error(response) {

            });




        };

        vm.loadData = function () {

            $http({
                method: 'GET',
                url: TREE_URL,
                headers: {'Authorization': 'Bearer ' + vm.token},
                data: {}
            }).then(function sucess(data) {
                // login successful if there's a token in the response
                //  vm.treeData = data.data;
                vm.treeData = [];

                vm.treeData = data.data;
                vm.treeConfig.version++;

            }, function error(response) {

            });

        };

        vm.reCreateTree = function () {
            vm.treeConfig.version++;

//  vm.treeInstance.refresh(true);
        };


        vm.testa = function () {

            $scope.checked = !$scope.checked;
        };

        vm.testb = function () {

            vm.token = "";
            sessionStorageService.remove('auth');
            $location.path("/auth");

        };

        vm.testc = function () {
            vm.loadData();
            //$scope.pdfUrl = 'http://localhost:8080/document/getfile';
            //vm.pdfUrk = "a.pdf";
        };

        vm.testd = function () {

            $scope.treeInstance.jstree(true).close_all();
            /*
             vm.treeData = [
             {id: 'ajson1', parent: '#', text: 'Simple root node55555555', state: {opened: true}},
             {id: 'ajson2', parent: '#', text: 'Root node 25555555555', state: {opened: true}},
             {id: 'ajson3', parent: 'ajson2', text: 'Child 1', state: {opened: true}},
             {id: 'ajson4', parent: 'ajson2', text: 'Child 2', state: {opened: true}}
             ];
             
             vm.treeConfig.version++;
             */
        };

        vm.search = function () {

            //$scope.treeInstance.jstree(true).close_all();
          //  $scope.treeInstance.jstree("search","angu");
            $scope.treeInstance.jstree(true).search("10.pdf");
    
        };

        vm.selectNode = function (a, b) {

            if (b.node.original.type !== "folder") {
                // $scope.httpHeaders = {'Authorization': 'Bearer ' + vm.token};
                // 'http://doclib.jpapou.fr/api/document'
                // LOCAL 'http://localhost:8080/document/getfile/' 

                $scope.pdfUrl = PDF_URL + b.node.id;
                $log.info($scope.pdfUrl);
            }
        };


        vm.ignoreModelChanges = function () {
            return false;
        };


/////////////////////////////////////////////////////////:

        vm.getNavStyle = function (scroll) {
            if (scroll > 100)
                return 'pdf-controls fixed';
            else
                return 'pdf-controls';
        };


        ///$scope.pdfUrl = '/03b.pdf';

        $scope.httpHeaders = {Authorization: 'Bearer some-aleatory-token'};
        $scope.loading = 'loading';

        $scope.onError = function (error) {
            // handle the error
            $log.info(error);
        };

        $scope.onProgress = function (progress) {
            // handle a progress bar
            //progress% = progress.loaded / progress.total 
           var value = progress.loaded / progress.total;
             $log.info(value*100);
          /*
            $("#myBar").width(value*100 + "%");
          //  $log.info(progress);
            if ( progress.loaded === progress.total) {
                $("#myProgress").hide();
            } else {
                $("#myProgress").show();
            }
            */
        };

        $scope.onLoad = function () {
            $scope.loading = '';
        };

        var authObj = sessionStorageService.get('auth');

        if (authObj === undefined) {
            $location.path('/auth');
        } else {
            var obj = JSON.parse(authObj);
            //$log.info('retrievedObject: ', obj);

            vm.token = obj.token;
            $scope.httpHeaders = {'Authorization': 'Bearer ' + vm.token};

// $scope.pdfUrl = 'http://localhost:8080/document/getfile/4';

        }

        $scope.checked = true;
        vm.loadData();

    }
})();

(function () {
    'use strict';

    angular
            .module('d')
            .controller('AuthController', AuthController);

    /** @ngInject */
    function AuthController($timeout, webDevTec, toastr, $scope, $http, $log, $location, AuthenticationService) {
        
        

        var vm = this;
        vm.login = login;
 
        (function initController() {
            // reset login status
            //AuthenticationService.ClearCredentials();
            
        })();
 
        function login() {
            vm.dataLoading = true;
            AuthenticationService.Login(vm.username, vm.password, function (response) {
                if (response) { // response.success
                   // TODO AuthenticationService.SetCredentials(vm.username, vm.password);
                    $location.path('/');
                    
                } else {
                   // FlashService.Error(response.message);
                    vm.dataLoading = false;
                }
            });
        }
        
        
    }
})();

(function() {
  'use strict';

  angular
    .module('d')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log, $rootScope) {

    $log.debug('runBlock end');
      $rootScope.$on('$routeChangeError', function (evt, current, previous, rejection) {
        console.log('Route error', rejection);
    });
  }

})();

(function() {
  'use strict';

  angular
    .module('d')
    .config(routeConfig);

  function routeConfig($routeProvider) {
    $routeProvider
      .when('/', {
        templateUrl: 'app/main/main.html',
        controller: 'MainController',
        controllerAs: 'main'
      })
      .when('/auth', {
        templateUrl: 'app/auth/auth.html',
        controller: 'AuthController',
        controllerAs: 'auth'
      })
      .otherwise({
        redirectTo: '/'
      });
  }

})();

/* global malarkey:false, moment:false */
(function() {
  'use strict';

  angular
    .module('d')
    .constant('malarkey', malarkey)
    .constant('moment', moment)
    
    .constant('getdocument', 'https://doclibapi.jpapou.fr/document')

/*
    .constant('LOGIN_URL',  'http://localhost:8080/authenticate')
    .constant('PDF_URL',    'http://localhost:8080/document/getfile/')
    .constant('TREE_URL',   'http://localhost:8080/document')
    .constant('TREE_URL_TEST',  'https://doclib.jpapou.fr/test.php')
*/
  
 
    .constant('LOGIN_URL',  'https://doclib.jpapou.fr/api/authenticate')
    .constant('PDF_URL',    'https://doclib.jpapou.fr/api/document/getfile/')   
    .constant('TREE_URL',   'https://doclib.jpapou.fr/api/document')
    .constant('TREE_URL_TEST',  'https://doclib.jpapou.fr/test.php')

    
    //.constant('TREE_URL',   'https://doclib.jpapou.fr/api/document')
    //.constant('TREE_URL',  'http://doclib.jpapou.fr/test.php')
    
    /*
       
    .constant('LOGIN_URL',  'http://localhost:8080/authenticate')
    
     */
    
    
    ;

})();

(function() {
  'use strict';

  angular
    .module('d')
    .config(config);

  /** @ngInject */
  function config($logProvider, toastrConfig) {
    // Enable log
    $logProvider.debugEnabled(true);

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = true;
    toastrConfig.progressBar = true;
  }

})();

angular.module("d").run(["$templateCache", function($templateCache) {$templateCache.put("app/auth/auth.html","<div class=container><div class=\"col-md-6 col-md-offset-3\"><h2>Login</h2><form name=form ng-submit=auth.login() role=form><div class=form-group ng-class=\"{ \'has-error\': form.username.$dirty && form.username.$error.required }\"><label for=username>Username</label><input type=text name=username id=username class=form-control ng-model=auth.username required> <span ng-show=\"form.username.$dirty && form.username.$error.required\" class=help-block>Username is required</span></div><div class=form-group ng-class=\"{ \'has-error\': form.password.$dirty && form.password.$error.required }\"><label for=password>Password</label><input type=password name=password id=password class=form-control ng-model=auth.password required> <span ng-show=\"form.password.$dirty && form.password.$error.required\" class=help-block>Password is required</span></div><div class=form-actions><button type=submit ng-disabledf=\"form.$invalid || vm.dataLoading\" class=\"btn btn-primary\">Login</button> <img ng-if=vm.dataLoading src=\"data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==\"> <a href=#!/register class=\"btn btn-link\">Register</a></div></form></div></div>");
$templateCache.put("app/main/main.html","<div class=container><!--\n        <button class=\"btn\" type=\"button\" ng-click=\"main.reCreateTree()\">reCreateTree</button>\n        <button class=\"btn\" type=\"button\" ng-click=\"main.loadDataTest()\">loadDataTest</button>\n       <h5>11111 {{main.creationDate}}</h5>\n    --><div id=myProgress style=\"visibility: hidden\"><div id=myBar></div></div><div class=row><button class=\"btn btn-sm\" type=button ng-click=main.testd()>close all</button> <button class=\"btn btn-sm btn-success\" type=button ng-click=main.testa()>Open/Close treeview</button> <button class=\"btn btn-sm btn-danger\" type=button ng-click=main.search()>search</button> <button class=\"btn btn-sm btn-info\" type=button ng-click=main.testb()>Disconnect</button><pageslide ps-open=checked ps-side=left ps-push=true><div ng-controllerjjj=MainController><button class=\"btn btn-sm btn-warning\" type=button ng-click=main.reCreateTree()>Re Create Tree</button><div js-tree=main.treeConfig class=\"jstree jstree-1 jstree-default jstree-default-small\" style=\"overflow: auto; height: 600px;width: 300px\" ng-model=main.treeData should-apply=main.ignoreModelChanges() tree=treeInstance tree-events=select_node:main.selectNode;></div><button class=\"btn btn-sm\" type=button ng-click=main.testc()>Re Create testb</button></div></pageslide><div class=wrapper ng-controller=MainController><ng-pdf template-url=app/main/viewer.html scale=page-fit></ng-pdf></div></div></div>");
$templateCache.put("app/main/viewer.html","<nav ng-class=main.getNavStyle(scroll)><button ng-click=goPrevious()><span>&lt;</span></button> <button ng-click=goNext()><span>&gt;</span></button> <button ng-click=zoomIn()><span>+</span></button> <button ng-click=fit()><span>100%</span></button> <button ng-click=zoomOut()><span>-</span></button> <button ng-click=rotate()><span>90</span></button><!--  <canvas id=\"pdf-canvas\" class=\"rotate0\"></canvas> --> <span>Page: </span><input type=text min=1 ng-model=pageNum><span>/ {{pageCount}}</span></nav>");
$templateCache.put("app/components/navbar/navbar.html","<nav class=\"navbar navbar-static-top navbar-inverse\"><div class=container-fluid><div class=navbar-header><a class=navbar-brand href=https://github.com/Swiip/generator-gulp-angular><span class=\"glyphicon glyphicon-home\"></span> Gulp Angular</a></div><div class=\"collapse navbar-collapse\" id=bs-example-navbar-collapse-6><ul class=\"nav navbar-nav\"><li class=active><a ng-href=#>Home</a></li><li><a ng-href=#>About</a></li><li><a ng-href=#>Contact</a></li></ul><ul class=\"nav navbar-nav navbar-right acme-navbar-text\"><li>Application was created {{ vm.relativeDate }}.</li></ul></div></div></nav>");}]);